/**
 * Cadastro de lead → cliente Shopify (App Proxy / Admin API).
 * Compartilhado: landing /pages/orcamento e modal WhatsApp na PDP.
 */
(function (global) {
  'use strict';

  var PHONE_DIGIT_MIN = 10;
  var PHONE_DIGIT_MAX = 11;

  function phoneDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function formatBrazilPhone(digits) {
    var d = digits.slice(0, PHONE_DIGIT_MAX);
    if (d.length === 0) return '';
    if (d.length <= 2) return '(' + d;
    if (d.length <= 7) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }

  function bindPhoneInput(input, invalidMessage) {
    if (!input) return;

    var sanitize = function () {
      input.value = formatBrazilPhone(phoneDigits(input.value));
      input.setCustomValidity('');
    };

    input.addEventListener('input', sanitize);
    input.addEventListener('blur', function () {
      if (!validatePhoneInput(input, invalidMessage, false)) {
        input.reportValidity();
      }
    });
    input.addEventListener('paste', function (event) {
      event.preventDefault();
      var pasted = (event.clipboardData && event.clipboardData.getData('text')) || '';
      input.value = formatBrazilPhone(phoneDigits(pasted));
      input.setCustomValidity('');
    });

    if (input.value) {
      input.value = formatBrazilPhone(phoneDigits(input.value));
    }
  }

  function validatePhoneInput(input, invalidMessage, report) {
    if (!(input instanceof HTMLInputElement)) return true;
    if (report === undefined) report = true;

    var min = Number(input.dataset.phoneMin || PHONE_DIGIT_MIN);
    var max = Number(input.dataset.phoneMax || PHONE_DIGIT_MAX);
    var digits = phoneDigits(input.value);

    if (digits.length < min || digits.length > max) {
      input.setCustomValidity(invalidMessage);
      if (report) input.reportValidity();
      return false;
    }

    input.setCustomValidity('');
    return true;
  }

  function resolveCustomerApiUrl(configured) {
    var url = String(configured || '').trim();
    if (url) return url;
    return '/apps/vestfirma-leads/customer';
  }

  function buildLeadNote(fields) {
    var lines = [];
    var push = function (label, value) {
      var text = String(value || '').trim();
      if (text) lines.push(label + ': ' + text);
    };

    push('Produto', fields.product);
    push('Link', fields.productUrl);
    push('Variante', fields.variant);
    push('WhatsApp', fields.phone);
    push('Nome', fields.name);
    push('E-mail', fields.email);
    push('Quantidade', fields.quantity);
    push('Dúvida', fields.question);
    push('Empresa', fields.company);
    push('Prioridade', fields.priority);
    push('Segmento', fields.segment);
    push('Finalidade', fields.purpose);
    push('Origem', fields.source);

    return lines.join('\n');
  }

  function syncLeadCustomer(apiUrl, payload) {
    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      keepalive: true,
    }).then(function (response) {
      if (response.ok) return response.json().catch(function () { return { ok: true }; });
      return response.text().then(function (detail) {
        console.warn('[vestfirma-lead] Cliente não cadastrado:', response.status, detail);
        return { ok: false, status: response.status, detail: detail };
      });
    });
  }

  global.VestfirmaLeadCustomer = {
    phoneDigits: phoneDigits,
    formatBrazilPhone: formatBrazilPhone,
    bindPhoneInput: bindPhoneInput,
    validatePhoneInput: validatePhoneInput,
    resolveCustomerApiUrl: resolveCustomerApiUrl,
    buildLeadNote: buildLeadNote,
    syncLeadCustomer: syncLeadCustomer,
  };
})(window);
